import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconCheckCircle = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 24 24'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M12.000,24.000 C5.383,24.000 0.000,18.617 0.000,12.000 C0.000,5.383 5.383,0.000 12.000,0.000 C18.617,0.000 24.000,5.383 24.000,12.000 C24.000,18.617 18.617,24.000 12.000,24.000 ZM12.000,2.000 C6.486,2.000 2.000,6.486 2.000,12.000 C2.000,17.514 6.486,22.000 12.000,22.000 C17.514,22.000 22.000,17.514 22.000,12.000 C22.000,6.486 17.514,2.000 12.000,2.000 ZM11.752,16.658 C11.555,16.884 11.278,17.000 11.000,17.000 C10.780,17.000 10.559,16.928 10.376,16.781 L5.375,12.781 C4.944,12.436 4.874,11.807 5.219,11.375 C5.565,10.944 6.195,10.874 6.624,11.219 L10.877,14.621 L17.248,7.342 C17.612,6.926 18.243,6.884 18.659,7.247 C19.074,7.611 19.116,8.243 18.752,8.658 L11.752,16.658 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconCheckCircle.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
